import { GetCategoryListDataTypes } from "../Schema/getCategoryList.types";

export const categories: { fa: GetCategoryListDataTypes[]; en: GetCategoryListDataTypes[] } = {
  en: [
    {
      id: 4,
      title_slug_id: 10,
      desc_slug_id: 355,
      info_slug_id: 671,
      icon_link: "1",
      title: {
        message: "Medical",
        laravel_through_key: 10,
      },
      desc: {
        message:
          "Instant access to medical services, consultations, prescriptions, and follow-ups — smart, detailed care without leaving home.",
        laravel_through_key: 355,
      },
    },
    {
      id: 6,
      title_slug_id: 139,
      desc_slug_id: 158,
      info_slug_id: 672,
      icon_link: "1",
      title: {
        message: "Lifestyle",
        laravel_through_key: 139,
      },
      desc: {
        message:
          "Redesign your life with science-backed guidance on nutrition, sleep, stress, and productivity for a healthier, smarter lifestyle.",
        laravel_through_key: 158,
      },
    },
    {
      id: 8,
      title_slug_id: 347,
      desc_slug_id: 348,
      info_slug_id: 349,
      icon_link: "1",
      title: {
        message: "Legal",
        laravel_through_key: 347,
      },
      desc: {
        message:
          "Get quick expert legal advice, document drafting, and analysis — your personal digital lawyer, always accessible and up to date.",
        laravel_through_key: 348,
      },
    },
  ],
  fa: [
    {
      id: 4,
      title_slug_id: 10,
      desc_slug_id: 355,
      info_slug_id: 671,
      icon_link: "1",
      title: {
        message: "پزشکی",
        laravel_through_key: 10,
      },
      desc: {
        message:
          "دسترسی فوری به خدمات پزشکی، مشاوره تخصصی، نسخه‌نویسی و پیگیری درمان بدون خروج از خانه؛ مراقبت سلامت، با جزئیات مورد نیاز و صرفه جویی در زمان مبنی بر شیوه‌ای دیجیتال و هوشمند.",
        laravel_through_key: 355,
      },
    },
    {
      id: 6,
      title_slug_id: 139,
      desc_slug_id: 158,
      info_slug_id: 672,
      icon_link: "1",
      title: {
        message: "سبک زندگی",
        laravel_through_key: 139,
      },
      desc: {
        message:
          "با استفاده از این سرویس، سبک زندگی‌تان را مبنی بر اصول مدرن و علمی بازطراحی کنید؛ از تغذیه و خواب تا مدیریت استرس و بهره‌وری، همه چیز در مسیر یک زندگی سالم و هوشمند.",
        laravel_through_key: 158,
      },
    },
    {
      id: 8,
      title_slug_id: 347,
      desc_slug_id: 348,
      info_slug_id: 349,
      icon_link: "1",
      title: {
        message: "حقوقی",
        laravel_through_key: 347,
      },
      desc: {
        message:
          "از مشاوره سریع و تخصصی تا تولید و تحلیل اسناد حقوقی؛ این سرویس، وکیل دیجیتال شخصی شماست که همیشه با بروز ترین قوانین به صورت هوشمند در دسترس است.",
        laravel_through_key: 348,
      },
    },
  ],
};
